import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import Analytics from "./views/Analytics";
import DataScience from "./views/DataScience";
import DataManagement from "./views/DataManagement";
import MachineLearning from "./views/MachineLearning";
import Blog from "./views/Blog";
import CaseStudies from "./views/CaseStudies";
import Platform from "./views/Platform";
import Contact from "./views/Contact";
import Content from "./views/Content";
import CaseStudy from "./views/CaseStudy";
import Guides from "./views/Guides";
import Guide from "./views/Guide";
import Privacy from "./views/Privacy";
import Analyses from "./views/Analyses";
import Analysis from "./views/Analysis";
import VueMeta from "vue-meta";

Vue.use(Router);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/Services/Analytics",
      name: "Analytics",
      component: Analytics,
    },
    {
      path: "/Services/Data-Science",
      name: "Data Science",
      component: DataScience,
    },
    {
      path: "/Services/Data-Management",
      name: "Data Management",
      component: DataManagement,
    },
    {
      path: "/Services/Machine-Learning",
      name: "Machine Learning",
      component: MachineLearning,
    },
    {
      path: "/Content/Blog",
      name: "Blog",
      component: Blog,
    },
    {
      path: "/Content/Case-Studies",
      name: "Case Studies",
      component: CaseStudies,
    },
    {
      path: "/Content/Guides",
      name: "Guides",
      component: Guides,
    },
    {
      path: "/Content/Analyses",
      name: "Analyses",
      component: Analyses,
    },
    {
      path: "/White-Label-Business-Intelligence-Platform",
      name: "White Label Business Intelligence Platform",
      component: Platform,
    },
    {
      path: "/Contact",
      name: "Contact",
      component: Contact,
    },
    {
      path: "/Privacy",
      name: "Privacy",
      component: Privacy,
    },
    {
      path: "/Content/Post/:postName",
      name: "Content",
      component: Content,
    },
    {
      path: "/Content/Analysis/:postName",
      name: "Analysis",
      component: Analysis,
    },
    {
      path: "/Case-Study/:postName",
      name: "Case Study",
      component: CaseStudy,
    },
    {
      path: "/Guide/:postName",
      name: "Guide",
      component: Guide,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to) {
    if (to.path === "/Services/Analytics") return { x: 0, y: 0 };
    if (to.path === "/Services/Data-Science") return { x: 0, y: 0 };
    if (to.path === "/Services/Data-Management") return { x: 0, y: 0 };
    if (to.path === "/Services/Machine-Learning") return { x: 0, y: 0 };
    if (to.path === "/Content/Blog") return { x: 0, y: 0 };
    if (to.path === "/Content/Case-Studies") return { x: 0, y: 0 };
    if (to.path === "/Content/Guides") return { x: 0, y: 0 };
    if (to.path === "/Content/Analyses") return { x: 0, y: 0 };
    if (to.path === "/White-Label-Business-Intelligence-Platform")
      return { x: 0, y: 0 };
    if (to.path === "/Contact") return { x: 0, y: 0 };
    if (to.path === "/Privacy") return { x: 0, y: 0 };
    if (to.path === "/Content/Post/*?post_id=*") return { x: 0, y: 0 };
    if (to.path === "/Case-Study/*?post_id=*") return { x: 0, y: 0 };
    if (to.path === "/Guide/*?post_id=*") return { x: 0, y: 0 };
    if (to.path === "/") return { x: 0, y: 0 };
    if (to.path === "/*") return { x: 0, y: 0 };
  },
});

export default router;
